import React from 'react';
import { DataCell } from '../selectRefundReasonAndReceipt/StudentDetails';
import styles from "../styles.module.scss";
import ReceiptsList from '../selectRefundReasonAndReceipt/selectReceipt/ReceiptsList';
import { UploadedFile } from '../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/UploadDocument';

const RefundDetailsSummary = ({
    rectRefundStep2Data
}) => {

    const { refundDetailsForm, studentDetailsCorrectionForm, selectedReceipt , showCorrectStudentDetailsForm} = rectRefundStep2Data;

    const {
        rectificationReason,
        paymode,
        attachmentKey,
        remarks
    } = refundDetailsForm;

    const {
        applicationId,
        psid,
        studentName,
        businessAreaDispVal,
        courseId,
        termDispVal
    } = studentDetailsCorrectionForm


    return (
        <div className={`a-card m-0 mt-3 ${styles['refund-details-card']}`}>
            <h2>Refund Details</h2>

            <div className={styles['refund-reason-form']}>

                <DataCell label={"Rectification Reason"} value={rectificationReason?.label} />
                <DataCell label={"Paymode"} value={paymode?.label} />
                <DataCell label={"Attachment"}>
                    <UploadedFile viewOnly attachmentKey={attachmentKey}/>
                </DataCell>
                <DataCell label={"Remarks"} value={remarks} />

            </div>

            {showCorrectStudentDetailsForm &&

                <div className={`${styles['student-details-correction-form']}`}>

                    <div className={`${styles['title']}`}>Correct Student Details</div>

                    <div className={styles['student-details']}>

                        <DataCell label={"Correct Application Id"} value={applicationId} />
                        <DataCell label={"Correct PSID"} value={psid} />
                        <DataCell label={"Student Name"} value={studentName} />
                        <DataCell label="BU" value={businessAreaDispVal} />
                        <DataCell label="Course ID" value={courseId} />
                        <DataCell label="Term" value={termDispVal} />

                    </div>

                </div>
            }

            <div style={{borderRadius : '12px', border : '1px solid #E2E2E2', height : '150px'}} className='mt-3 p-3'>

                <h3>Old Receipt</h3>

                <hr/>

                <ReceiptsList
                receiptsData={selectedReceipt ? [selectedReceipt] : []}
                checkboxSelection={false}
                />

            </div>


        </div>
    );
}

export default RefundDetailsSummary;